import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_CATEGORIES_STATS } from '../../../../query/monitor/data/sources/keys';
import { getCategoriesStats } from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';
import { CategoriesStatsResponse } from '../../../../../models/monitor/data/sources/CategoriesStatsResponse';

export const useGetCategoriesStats = (
  projectId: number | null,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  useSourceCategory?: boolean,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: categoriesStats,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<CategoriesStatsResponse>({
    queryKey: [GET_CATEGORIES_STATS, projectId, chatType, fromTimestamp, toTimestamp, useSourceCategory, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getCategoriesStats(projectId!, chatType!, from, to, useSourceCategory, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    categoriesStats: queryEnabled
      ? categoriesStats ?? {
          categories: [],
          total: 0,
        }
      : {
          categories: [],
          total: 0,
        },
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_CATEGORIES_STATS, projectId, chatType, fromTimestamp, toTimestamp, useSourceCategory, monitorPromptIds, filterMonitorTypes],
        refetchType: 'active',
      }),
  };
};

